import { Injectable, Injector, inject } from '@angular/core';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { TranslateService } from '@ngx-translate/core';
import { DialogConfirmComponent } from '@src/app/shared/dialogs';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private readonly dialogService = inject(TuiDialogService);
  private readonly injector = inject(Injector);
  private readonly translateService = inject(TranslateService);

  readonly confirmDeleteChatDialog = this.dialogService.open<boolean>(
    new PolymorpheusComponent(DialogConfirmComponent, this.injector),
    {
      label: this.translateService.instant('components.internalMessenger.dialogs.chatDeleteHeader'),
      size: 's',
      closeable: false,
    },
  );

  readonly confirmLeaveChatDialog = this.dialogService.open<boolean>(
    new PolymorpheusComponent(DialogConfirmComponent, this.injector),
    {
      label: this.translateService.instant('components.internalMessenger.dialogs.chatLeaveHeader'),
      size: 's',
      closeable: false,
    },
  );

  readonly confirmMakeAdminDialog = this.dialogService.open<boolean>(
    new PolymorpheusComponent(DialogConfirmComponent, this.injector),
    {
      label: this.translateService.instant('components.internalMessenger.dialogs.makeAdminHeader'),
      size: 's',
      closeable: false,
    },
  );

  readonly confirmDemoteAdminDialog = this.dialogService.open<boolean>(
    new PolymorpheusComponent(DialogConfirmComponent, this.injector),
    {
      label: this.translateService.instant('components.internalMessenger.dialogs.demoteAdminHeader'),
      size: 's',
      closeable: false,
    },
  );

  readonly confirmRemoveChatMemberDialog = this.dialogService.open<boolean>(
    new PolymorpheusComponent(DialogConfirmComponent, this.injector),
    {
      label: this.translateService.instant('components.internalMessenger.dialogs.chatMemberDeleteHeader'),
      size: 's',
      closeable: false,
    },
  );

  readonly confirmDeleteMessageDialog = this.dialogService.open<boolean>(
    new PolymorpheusComponent(DialogConfirmComponent, this.injector),
    {
      label: this.translateService.instant('components.internalMessenger.dialogs.chatMessageDeleteHeader'),
      size: 's',
      closeable: false,
      dismissible: false,
    },
  );
}
